import React from 'react';
import { compose } from 'ramda';
import Grid from '@material-ui/core/Grid';
import { showToast } from '@deeptrue-frontend/ui';
import { FormikHelpers } from 'formik';

import { useFormatMessage } from 'components/IntlProvider';
import StoreProvider from 'components/StoreProvider/StoreProvider';
import { Dashboard } from 'components/Layout';
import Forms from 'components/Forms';
import { withMetaDescription } from 'components/HeadProvider/HeadProvider';
import api from 'api/api';
import SettingsMenu from './SettingsMenu';
import { FormValues } from 'components/Forms/Email';
import { translateFieldErrors } from 'components/IntlProvider/translateFieldErrors';

const { connect, actions, selectors } = StoreProvider;

const Settings = ({ updateUserProfile, location, initialValues }: any) => {
  const t = useFormatMessage();

  const updateEmail = (
    values: FormValues,
    { setErrors, setFieldValue }: FormikHelpers<FormValues>
  ) => {
    return api.resources
      .updateUserEmail({ new_email: values.new_email })
      .then(({ data }) => {
        updateUserProfile(data);
        setFieldValue('actual_email', values.new_email);

        showToast({
          type: 'success',
          title: t('errors.settings.changesSave', 'Changes saved'),
        });
      })
      .catch((err) => {
        setErrors(
          translateFieldErrors({
            t,
            err: err.response.data,
          })
        );
      });
  };

  return (
    <Dashboard
      title={t('profile.title', 'Settings')}
      headerTitle={t('profile.email.title', 'Update Email')}
      headerSubtitle={t(
        'profile.email.subtitle',
        'Here you can change your email address'
      )}
      location={location}
    >
      <Grid item xs={12}>
        <SettingsMenu />
      </Grid>
      <Grid item xs={12} sm={12} md={10} lg={6}>
        <Forms.Email
          onSubmit={updateEmail}
          initialValues={{
            new_email: '',
            confirm_email: '',
            actual_email: initialValues.email,
          }}
        />
      </Grid>
    </Dashboard>
  );
};

export default compose(
  connect(
    (state: any) => ({
      initialValues: selectors.authSelectors.userProfile(state),
    }),
    {
      updateUserProfile: actions.authActions.userUpdate,
    }
  ),
  withMetaDescription({ title: 'Settings > Email' })
)(Settings);
